var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#818E9C",
    fillRule: "evenodd",
    d: "M13.905 4.246a.841.841 0 0 1 1.19 1.19l-9.228 9.228-1.586.396.396-1.586 9.228-9.228ZM14.5 2.5a2.34 2.34 0 0 0-1.655.686L3.47 12.56a.75.75 0 0 0-.198.348l-.75 3a.75.75 0 0 0 .91.91l3-.75a.75.75 0 0 0 .348-.198l9.375-9.375A2.342 2.342 0 0 0 14.5 2.5ZM10 15.341a.75.75 0 0 0 0 1.5h6.75a.75.75 0 0 0 0-1.5H10Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5f90e57346da2ad797568adbfc6ccf8a.svg";
export { ForwardRef as ReactComponent };